<template>
    <div class="help">
        <div class="help__inner">
            <h1 class="help__heading heading">Не нашли то, что искали?</h1>
            <p class="help__text">Напишите какой букет вы бы хотели и мы сделаем его индивидуальным заказом</p>
            <button 
                type="button" 
                @click="openConsultation"
                class="help__btn">Заказать букет</button>
        </div>
        <ConsultationPopup
            @closeConsultation="closeConsultation"
            v-if="isConsultation"/>
    </div>
</template>

<script>
import ConsultationPopup from '@/components/popups/Consultation-popup'

export default {
    data() {
        return {
            isConsultation: false
        }
    },
    components: {
        ConsultationPopup
    },
    methods: {
        closeConsultation(){
            this.isConsultation = false
        },
        openConsultation(){
            this.isConsultation = true
        }
    },
}
</script>

<style scoped>
    .help__inner{
        padding: 50px;
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #ECDED3;
        border-radius: 70px 120px 120px 70px;
    }
    .help__heading{
        margin-bottom: 35px;
        line-height: 135%;
    }
    .help__text{
        margin-bottom: 50px;
        font-size: 20px;
        max-width: 435px;
        text-align: center;
        line-height: 135%;
    }
    .help__btn{
        font-family: "Bona Nova", serif;
        padding: 16px 60px;
        color: #ECDED3;
        background-color: #3A3841;
        border-radius: 20px;
        font-size: 20px;
        transition: all linear .2s;
    }
    .help__btn:hover{
        opacity: .5;
    }
    @media (max-width: 600px) {
        .help__inner{
            border-radius: 30px 60px 60px 30px;
            padding: 30px 15px;
        }
        .help__heading{
            text-align: center;
            margin-bottom: 25px;
            max-width: 215px;
        }
        .help__text{
            font-size: 16px;
            margin-bottom: 50px;
            max-width: 315px;
        }
        .help__btn{
            padding: 17px 40px;
            line-height: 135%;
            font-size: 18px;
        }
    }
</style>